<template>
    <div>
        <el-form ref="form" :model="formItem" label-width="0">
            <el-form-item label="" class="label-required" style="margin-bottom: 0;">
                <el-select v-model="formItem.select" placeholder="Please select" class="full-w">
                    <el-option
                        v-for="item in optionList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer tac">
            <el-button type="default" @click="$emit('close')" class="action-btn mr20">Cancel</el-button>
            <el-button type="primary" @click="handleSubmit" :loading="submitLoading" class="action-btn ml20">Submit</el-button>
        </div>
    </div>
</template>

<script>
    export default {
        props: [ 'cbs', 'value', 'select' ],
        data() {
            return {
                dialogVisible: false,
                submitLoading: false,
                formItem: {
                    select:'',
                },
                // rules: {
                //     data_range: [
                //         {type: 'array', required: true, message: '请选择日期', trigger: 'change'}
                //     ]
                // },
                optionList:[],

            }
        },
        computed: {

        },
        methods: {
            handleSubmit() {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        let selectItem = this.optionList.find(item=>item.value==this.formItem.select)||{};
                        this.$emit('save-value',this.modalData,{
                            select:this.formItem.select,
                            selectLabel:selectItem.label,
                        },'select');
                    } else {
                        return false;
                    }
                });
            },

        }
    }
</script>

<style lang="scss" scoped>
    .action-btn {
        /*width: 120px;*/
    }

    ::v-deep .el-dialog__body{
        padding: 20px;
    }

</style>
